export default {
    isRecaptchaEnabled: () => {
        if (window.initInfo && typeof window.initInfo.is_recaptcha_enabled == 'boolean')
            return window.initInfo.is_recaptcha_enabled;
        else return true;
    },

    getRecaptchaURL: () => {
        let url = 'https://www.google.com/recaptcha/api.js';
        if (isRecaptchaGloballySupported()) {
            url = 'https://www.recaptcha.net/recaptcha/api.js';
        }
        return url;
    },

    isRecaptchaTextEnabled: () => {
        if(window.initInfo && window.initInfo.is_recaptcha_enabled && window.isMobile){
            return !!window.initInfo.is_recaptcha_text_enabled;
        }
        return false;
    }
}
export const isRecaptchaGloballySupported = () => {
    if (typeof window.initInfo.supported_global_recaptcha == 'boolean'
        && window.initInfo.supported_global_recaptcha == true) {
        return true;
    }
    return false;
}
